import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import BlurAmountView from 'design-system/BlurAmountView';
import { selectIsScrambled } from 'hooks';
import { useAppSelector } from 'store/hooks';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { formatAmount, interpolate } from 'utils';
const RowAccountGoalInfo = ({ accountId, pot, }) => {
    const goal = useAppSelector((store) => accountId ? store.accounts?.goals?.[accountId] : undefined);
    const scrambled = useAppSelector(selectIsScrambled);
    const { isUnlocked } = useShouldShowUpgrade({
        benefitId: 'savingGoals',
    });
    let percent;
    if (goal) {
        percent = goal.percentageProgress;
    }
    else if (pot?.goal) {
        percent = interpolate(pot.balance.value, {
            inputRange: [0, pot.goal.amount],
            outputRange: [0, 100],
        });
    }
    if (!isUnlocked || percent === undefined) {
        return null;
    }
    const formattedPercent = formatAmount(percent, undefined, 0, false, true);
    return (<View style={styles.scrambledContainer}>
      <BlurAmountView enabled={scrambled}>
        <Text TextThin-14 Secondary>
          {formattedPercent}%
        </Text>
      </BlurAmountView>
      <View style={styles.flex}>
        <Text TextThin-14 Secondary numberOfLines={1}>
          &nbsp;of your goal
        </Text>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    scrambledContainer: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
    },
});
export default React.memo(RowAccountGoalInfo);
